// extracted by mini-css-extract-plugin
export default {"pulse":"PulseData_pulse__hlBan"};